import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { reduxForm } from 'redux-form';

import styles from './ConfirmForm.module.css';
import { getDrawdownType } from '../../../drawDown/getDrawdownType';
import NextRepayment from '../../../funding/ConfirmFundingView/confirmForm/nextRepayment/NextRepayment';
import { SHOW_REPAYMENT_SCHEDULE_MODAL } from '../../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper';
import PairItemContainer from '../../../ui/pairItemContainer/PairItemContainer';
import { CONFIRM_FUNDING } from '../../Funding.actions';

const confirmDrawdownForm = {
    form: 'confirmDrawdown',
    enableReinitialize: true
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    confirm: (offerId: string) =>
        dispatch({
            type: CONFIRM_FUNDING,
            amount: 0,
            offerId
        }),
    showSchedule: () => dispatch({ type: SHOW_REPAYMENT_SCHEDULE_MODAL })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

type TProps = {
    formalOffer: TFormalOffer;
};

const Confirm = ({
    confirm,
    showSchedule,
    formalOffer
}: TProps & PropsFromRedux) => {
    const drawdownType = getDrawdownType(formalOffer);

    return (
        <div className={styles.Confirm}>
            <MainSectionWrapper className={styles.content}>
                <PairItemContainer>
                    <div className={styles.selectedAmount}>
                        <div className={styles.summaryTitle}>
                            {drawdownType === 'repayment_reduction' ? (
                                <FormattedMessage
                                    id="_.confirm_funding.top_up.repayment_reduction_summary_title"
                                    defaultMessage="You’ll reduce your monthly repayments by extending your loan. Your outstanding balance will not be affected."
                                />
                            ) : (
                                <FormattedMessage
                                    id="_.confirm_funding.top_up.interestOnly_summary_title"
                                    defaultMessage="You are extending your interest-only period"
                                />
                            )}
                        </div>
                    </div>

                    <div className={styles.repayments}>
                        <NextRepayment />
                        <div className={styles.showSchedule}>
                            <span
                                className={styles.link}
                                onClick={showSchedule}
                            >
                                <FormattedMessage
                                    id="_.confirm_funding.repayment_breakdown"
                                    defaultMessage="See full repayment schedule"
                                />
                            </span>
                        </div>
                    </div>
                </PairItemContainer>
            </MainSectionWrapper>
            <div className={styles.newFundingConfirmButton}>
                <Button
                    variant="success"
                    onClick={() => confirm(formalOffer.offer_id!)}
                    size="large"
                    data-action-name="Confirm funding"
                >
                    <FormattedMessage
                        id="_.confirm_funding.confirm"
                        defaultMessage="Confirm"
                    />
                </Button>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    null,
    mapDispatchToProps
)(reduxForm<any, TProps & PropsFromRedux>(confirmDrawdownForm)(Confirm));
